import {
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { authActions } from "../store/AuthSlice";
import { peopleActions } from "../store/PeopleSlice";
import { SSOAuthorization } from "more-sso-sdk";
import { login } from "../store/AuthSlice/thunk";
import AllModules from "../screens/AllModules";
import TaskBox from "../screens/TaskBox";
import SideBar from "../components/SideBar";
import People from "../screens/People";
import AddEmployee from "../screens/AddEmployee";
import ManageAccess from "../screens/ManageAccess";
import ReviewQueue from "../screens/ReviewQueue";
import ReviewRequest from "../screens/ReviewRequest";
import Documents from "../screens/Documents";
// import Module from "../components/InvalidRoute";
// import Assets from "../screens/Assets";
// import Recruitment from "../screens/Recruitment";
// import AddDesignation from "../screens/AddDesignation";
// import Login from "../screens/Login";
import Profile from "../screens/Profile";
import Loader from "../commonComponents/Loader";
import Separation from "../screens/Separation";
import Requests from "../screens/Requests";
import ErrorModal from "../commonComponents/ErrorModal";
import SeperationApproval from "../components/SeperationApproval";
import SeperationList from "../components/SeperationList";
import SeprerationExitForm from "../components/SeperationExitForm";
import Attendance from "../screens/Attendance";
import StorePass from "../screens/StorePass";
import Subscriptions from "../screens/Subscriptions";
import ArrowbackIcon from "../assets/icons/arrow_back.svg";

const RootRoutes = () => {
  const devEmployeeID = "402207";
  const [accessToken, setAccessToken] = useState(null);
  const isUserLogged = useSelector((state) => state.auth.isLoggedIn);
  const isPeopleExpanded = useSelector(
    (state) => state?.people?.userDetails?.user_details,
  );

  const loading = useSelector((state) => state.loader.loading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("\n\nLogin page JEDI");
    ssoLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (accessToken) {
      if (window.location.pathname === "/" || window.location.pathname === "") {
        navigate("/all");
      }
    }

    if (
      window.location.pathname.startsWith("/people") &&
      window.location.pathname !== "/people" &&
      window.location.pathname !== "/people/review-queue" &&
      !window.location.pathname.startsWith("/people/review-request")
    ) {
      window.location.href = "/people";
      dispatch(peopleActions.updateEdit(false));
      dispatch(peopleActions.updateDraft(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, dispatch, isUserLogged]);

  const ssoLogin = () => {
    if (process.env.NODE_ENV === "development") {
      console.log("SSO Login DEVELOPMENT ENV");
      SSOAuthorization.getDevToken("402045")
        .then((result) => {
          if (result) {
            console.log("SSO getDevToken result : ", result);
            setAccessToken(result);
            dispatch(authActions.setLoginDetails(result));
            dispatch(authActions.setLoggedIn(true));
            dispatch(authActions.setEmployeeID(devEmployeeID));
            dispatch(login({ employee_id: devEmployeeID }));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          dispatch(authActions.setLoading(false));
        });
    } else {
      console.log("SSO Login PRODUCTION ENV");

      const currentUrl = window.location.href;
      const encodedRedirect = encodeURIComponent(currentUrl);
      SSOAuthorization.getToken(encodedRedirect)
        .then((result) => {
          console.log("SSO getToken result done");
          if (result) {
            setAccessToken(result);
            dispatch(authActions.setLoginDetails(result));
            dispatch(authActions.setLoggedIn(true));
            if (result?.employee_id) {
              dispatch(authActions.setEmployeeID(result?.employee_id));
              dispatch(login({ employee_id: result?.employee_id }));
            }
          }
        })
        .catch(console.error)
        .finally(() => {
          dispatch(authActions.setLoading(false));
        });
    }
  };


  return (
    <div className="w-full position-relative">
      {loading && <Loader />}
      <ErrorModal />
      {accessToken ? (
        <div className="position-relative p-2 sm:p-3 flex flex-col lg:flex-row main-container min-h-screen">
          <div className="sidebar-wrapper hidden xl:block position-relative">
            <SideBar />
          </div>

          <div
            className={
              isPeopleExpanded
                ? "route-wrapper-ex w-full h-full"
                : "route-wrapper w-full h-full"
            }
          >
            <Routes>
              {/* <Route path="recruitment">
                  <Route index={true} element={<Recruitment />} />
                  <Route path="add" element={<AddDesignation />} />
                  </Route> */}
              <Route path="attendance" element={<Attendance />} />
              <Route path="documents" element={<Documents />} />
              <Route path="storepass" element={<StorePass />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              {/* <Route path="assets" element={<Assets />} /> */}
              <Route path="requests" element={<Requests />} />
              <Route path="separation">
                <Route path="*" element={<Navigate to="/separation" />} />
                <Route index={true} element={<Separation />} />
                <Route path="list" element={<SeperationList />} />
                <Route path="exit" element={<SeprerationExitForm />} />
              </Route>
              <Route path="people">
                <Route path="*" element={<Navigate to="/people" />} />
                <Route index={true} element={<People />} />
                <Route path="add" element={<AddEmployee />} />
                <Route path="manage" element={<ManageAccess />} />
                <Route path="review-queue" element={<ReviewQueue />} />
                <Route
                  path="review-request/:requestId"
                  element={<ReviewRequest />}
                />
              </Route>
              <Route path="profile" element={<Profile />} />
              <Route path="taskbox">
                <Route path="*" element={<Navigate to="/taskbox" />} />
                <Route index={true} element={<TaskBox />} />
                <Route path="approve" element={<SeperationApproval />} />
              </Route>
              <Route path="all" element={<AllModules />} />
              <Route path="*" element={<Navigate to={"/all"} />} />
            </Routes>
          </div>
        </div>
      ) : (
        <div className="p-12">
          <Routes>
            <Route
              path="error"
              element={() => {
                return (
                  <div>
                    <span>Something went wrong</span>
                  </div>
                );
              }}
            />
            {/* <Route path="login" element={<Login />} />
                <Route path="*" element={<Navigate to={"/all"} />} /> */}
          </Routes>
        </div>
      )}
    </div>
  );
};
export default RootRoutes;
